import { stepBaggageAndPersonalItemsSCTILookup as expenseLookup } from './claimCodeMapper';

function mapToParentSection() {
  return {};
}

function mapToQuestionnaire() {
  return [];
}

function mapToExpenses(data) {
  const expensesSelected = !!data.whatHappenedToYourBaggageAndPersonalItems && typeof data.whatHappenedToYourBaggageAndPersonalItems.toJS === 'function'
    ? data.whatHappenedToYourBaggageAndPersonalItems.toJS()
    : data.whatHappenedToYourBaggageAndPersonalItems || [];
  const baggageDelay = expensesSelected.includes('Baggage delay') ? mapToBaggageDelay(data) : [];
  const lostStolenOrDamagedItems = expensesSelected.includes('Lost, stolen or damaged items') ? mapToLostStolenOrDamaged(data) : [];
  return [...baggageDelay, ...lostStolenOrDamagedItems];
}

function mapToBaggageDelay(data) {
  if (data.infoBaggageDelayItems.length < 1) {
    return [];
  }

  const expenses = [];

  const claimCode = expenseLookup.daggageDelay.claimCode;
  data.infoBaggageDelayItems.forEach(
    (item) => {
      const expense = mapExpenseItem(item, data, claimCode);
      if (!!expense) {
        expenses.push(expense);
      }
    }
  );
  return expenses;
}

function mapToLostStolenOrDamaged(data) {
  const expensesLostItemSelected = !!data.whatItemsAreYouClaimingFor && typeof data.whatItemsAreYouClaimingFor.toJS === 'function'
    ? data.whatItemsAreYouClaimingFor.toJS()
    : data.whatItemsAreYouClaimingFor || [];
  if (data.infoEssentialMedicationItems.length < 1 &&
    data.infoJewelleryOrTraditionalWatchesItems.length < 1 &&
    data.infoLaptopsTabletsOrCamerasItems.length < 1 &&
    data.infoOtherUnspecifiedItems.length < 1 &&
    data.infoSpecifiedHighValueItems.length < 1 &&
    data.infoBankCardsOrTravelDocumentsItems.length < 1 &&
    data.infoCashItems.length < 1) {
    return [];
  }
  const expenses = [];
  let claimCode = expenseLookup.essentialMedication.claimCode;

  if (expensesLostItemSelected.includes('Essential medication')) {
    claimCode = expenseLookup.essentialMedication.claimCode;
    data.infoEssentialMedicationItems.forEach(
      (item) => {
        const expense = mapExpenseLostStolenOrDamagedItem(item, data, claimCode);
        if (!!expense) {
          expenses.push(expense);
        }
      }
    );
  }
  if (expensesLostItemSelected.includes('Jewellery or traditional watches')) {
    claimCode = expenseLookup.jewelleryOrTraditionalWatches.claimCode;
    data.infoJewelleryOrTraditionalWatchesItems.forEach(
      (item) => {
        const expense = mapExpenseLostStolenOrDamagedItem(item, data, claimCode);
        if (!!expense) {
          expenses.push(expense);
        }
      }
    );
  }
  if (expensesLostItemSelected.includes('Laptops, tablets or cameras')) {
    claimCode = expenseLookup.laptopsTabletsOrCameras.claimCode;
    data.infoLaptopsTabletsOrCamerasItems.forEach(
      (item) => {
        const expense = mapExpenseLostStolenOrDamagedItem(item, data, claimCode);
        if (!!expense) {
          expenses.push(expense);
        }
      }
    );
  }
  if (expensesLostItemSelected.includes('Other unspecified items')) {
    claimCode = expenseLookup.otherUnspecifiedTtems.claimCode;
    data.infoOtherUnspecifiedItems.forEach(
      (item) => {
        const expense = mapExpenseLostStolenOrDamagedItem(item, data, claimCode);
        if (!!expense) {
          expenses.push(expense);
        }
      }
    );
  }
  if (expensesLostItemSelected.includes('Specified high value items')) {
    claimCode = expenseLookup.specifiedHighValueItems.claimCode;
    data.infoSpecifiedHighValueItems.forEach(
      (item) => {
        const expensesFromItem = mapExpensesSpecifiedItem(item, data, claimCode);
        if (expensesFromItem && expensesFromItem.length > 0) {
          expenses.push(...expensesFromItem);
        }
      }
    );
  }
  if (expensesLostItemSelected.includes('Bank cards or travel documents')) {
    claimCode = expenseLookup.bankCardsOrTravelDocuments.claimCode;
    data.infoBankCardsOrTravelDocumentsItems.forEach(
      (item) => {
        const expense = mapExpenseLostStolenOrDamagedItem(item, data, claimCode);
        if (!!expense) {
          expenses.push(expense);
        }
      }
    );
  }
  if (expensesLostItemSelected.includes('Cash')) {
    claimCode = expenseLookup.cash.claimCode;
    data.infoCashItems.forEach(
      (item) => {
        const expense = mapExpenseLostStolenOrDamagedItem(item, data, claimCode);
        if (!!expense) {
          expenses.push(expense);
        }
      }
    );
  }

  return expenses;
}

function mapExpenseItem(item, itemDate, claimCode) {
  const selectedClaimForArray = item.selectedClaimFor ? (!Array.isArray(item.selectedClaimFor)) ? item.selectedClaimFor.toJS() : item.selectedClaimFor : [];
  const claimForInsuredIds = selectedClaimForArray.map((claimFor) => claimFor.policyRoleID);
  if (!item || !item.amountClaimed || !item.currency) {
    return null;
  }
  return {
    shortDescription: `${item.descriptionOfItem}`,
    dateOfExpense: item.dateOfExpenses,
    clientCost: item.amountClaimed,
    currency: item.currency,
    rate: null,
    requestedAmount: null,
    claimTypeCode: claimCode,
    claimForInsuredIds,
    claimForInsureds: selectedClaimForArray,
  };
}

function mapExpenseLostStolenOrDamagedItem(item, itemDate, claimCode) {
  const selectedClaimForArray = item.selectedClaimFor ? (!Array.isArray(item.selectedClaimFor)) ? item.selectedClaimFor.toJS() : item.selectedClaimFor : [];
  const claimForInsuredIds = selectedClaimForArray.map((claimFor) => claimFor.policyRoleID);
  if (!item || !item.amountClaimed || !item.currency) {
    return null;
  }
  return {
    shortDescription: `${item.descriptionOfItem}`,
    dateOfExpense: item.dateOfExpenses,
    clientCost: item.amountClaimed,
    currency: item.currency,
    rate: null,
    requestedAmount: null,
    claimTypeCode: claimCode,
    dateOfPurchase: item.dateOfPurchase,
    depreciationType: item.depreciationType,
    claimForInsuredIds,
    claimForInsureds: selectedClaimForArray,
  };
}

function mapExpensesSpecifiedItem(item, itemDate, claimCode) {
  if (!item || !item.currency || !Array.isArray(item.specifiedItemIds)) {
    return null;
  }

  const selectedClaimForArray = item.selectedClaimFor ? (!Array.isArray(item.selectedClaimFor)) ? item.selectedClaimFor.toJS() : item.selectedClaimFor : [];
  const claimForInsuredIds = selectedClaimForArray.map((claimFor) => claimFor.policyRoleID);
  const expenses = item.specifiedItemIds.map((specifiedItemId) => {
    const specifiedItem = item.specifiedItemList.find(
      (x) => x.id === specifiedItemId
    );

    if (!specifiedItem) return null;

    return {
      shortDescription: `${specifiedItem.covered}`,
      dateOfExpense: item.dateOfExpenses,
      clientCost: specifiedItem.amount,
      currency: item.currency,
      rate: null,
      requestedAmount: null,
      claimTypeCode: claimCode,
      dateOfPurchase: item.dateOfPurchase,
      claimForInsuredIds,
      claimForInsureds: selectedClaimForArray,
      depreciationType: item.depreciationType
    };
  });

  return expenses.filter((expense) => expense !== null);
}

export default {
  mapToParentSection,
  mapToQuestionnaire,
  mapToExpenses,
};



// WEBPACK FOOTER //
// ./app/containers/FastCover/dataMapper/stepBaggageAndPersonalItemsSCTIDataMapper.js